/**
 * Deze zorgt ervoor dat als er op een button js-trigger-permit als class staat
 * hij van de knop de data-permit-email-field, data-permit-phone-field, data-permit-sms-field selectors opzoekt
 * en deze waardes post naar een API call die een Permit inschiet bij GDL voor deze velden.
 * Als laatste kanje als het een lead flow is nog data-permit-is-lead op true zetten
 * zodat een lead permit ingeschoten wordt (Zorgt ervoor dat de lead campaignid gebruikt wordt)
 *
 * Dus de button ziet er dan zo uit:
 *
 * <button class="button is-primary has-arrow js-trigger-permit"
 *    data-gdl-type="submit-button"
 *    data-permit-email-field="#email"
 *    data-permit-phone-field="#phone"
 *    data-permit-sms-field="sms"
 *    data-permit-is-lead="false"
 * >
 *    <span>Volgende!</span>
 * </button>
 *
 * 1 van de –field velden is gewenst en de js-trigger-permit class.
 * Hij valideert ook het gewenste veld eerst voordat hij de permit inschiet.
 */

const permit = () => {
  $('.js-trigger-permit').click(function handleClick() {
    const $this = $(this);

    let valToken = '';
    if (document.getElementsByName('__RequestVerificationToken')[0]) {
      valToken = document.getElementsByName('__RequestVerificationToken')[0].value;
    }
    const emailInput = $($this.data('permit-email-field'));
    if (emailInput.length > 0) {
      if (!emailInput.valid()) return;
    }
    const phoneInput = $($this.data('permit-phone-field'));
    if (phoneInput.length > 0) {
      if (!phoneInput.valid()) return;
    }
    const smsInput = $($this.data('permit-sms-field'));
    if (smsInput.length > 0) {
      if (!smsInput.valid()) return;
    }

    const postParams = {
      phoneNumber: phoneInput.val() || null,
      emailAddress: emailInput.val() || null,
      sms: smsInput.val() || null,
      isLead: $($this.data('permit-is-lead')).val() || false,
    };

    $.ajax({
      method: 'POST',
      headers: {
        RequestVerificationToken: valToken,
      },
      contentType: 'application/json',
      url: '/gdl-api/permit',
      data: JSON.stringify(postParams),
    }).always((data) => {
      if (console) console.log(data); // eslint-disable-line no-console
    });
  });
};

export default permit;
